export default "__VITE_ASSET__BE$QKiVD__"